<template>
  <div>
    <div v-if="!loading">
      <Lynx-Title :text="form.name" v-if="form.id && form.name" v-once />
      <Lynx-Title text="Adicionar usuário" v-else />
      <form class="flex flex-col" @submit.prevent="onSubmit">
        <label class="w-full block px-1 tracking-wide text-gray-700 text-xs">
          <Lynx-Label label="Nome" />
          <Lynx-Input
            placeholder="Insira o nome"
            :error="$v.form.name.$error"
            v-model.trim="$v.form.name.$model"
            :validator="$v.form.name"
            :validations-message="validationsMessage.form.name"
          />
        </label>
        <label class="w-full block px-1 tracking-wide text-gray-700 text-xs">
          <Lynx-Label label="E-mail" />
          <Lynx-Input
            placeholder="Insira o e-mail"
            :error="$v.form.email.$error"
            v-model.trim="$v.form.email.$model"
            :validator="$v.form.email"
            :validations-message="validationsMessage.form.email"
          />
        </label>
        <label class="w-full block px-1 tracking-wide text-gray-700 text-xs">
          <Lynx-Label label="Senha" />
          <Lynx-Input
            placeholder="Insira a senha"
            type="password"
            v-model.trim="form.password"
          />
        </label>
        <label class="w-full block px-1 tracking-wide text-gray-700 text-xs">
          <Lynx-Label label="Confirme a senha" type="password" />
          <Lynx-Input
            placeholder="Confirme a senha"
            type="password"
            v-model.trim="form.password_confirmation"
          />
        </label>
        <div class="pb-8">
          <span
            class="text-lg font-display border-b border-neutral-400 w-full pb-2 flex mb-4"
            >Permissões</span
          >
          <div class="flex flex-wrap">
            <label
              class="flex pr-8 pb-4"
              v-for="permission in permissions"
              :key="permission.id"
            >
              <b-checkbox
                v-model="form.permissions"
                :native-value="permission.name"
              />
              <span class="pl-1" v-text="permission.name"></span>
            </label>
          </div>
        </div>
        <div class="flex justify-between">
          <router-link :to="{ name: 'users.index' }">
            <Lynx-Button size="is-normal" class="is-light" text="Voltar" />
          </router-link>
          <Lynx-Button
            size="is-normal"
            class="is-success"
            type="submit"
            text="Salvar"
            :loading="loadingButton"
          />
        </div>
      </form>
    </div>
    <Lynx-OverlaySpinner v-else :loading="loading" />
  </div>
</template>

<script>
import { usersCreateRequest } from "../../services/requests/users";

import { required, email } from "vuelidate/lib/validators";
import { rolesUserShowRequest } from "../../services/requests/roles";

export default {
  name: "UsersCreate",
  data() {
    return {
      form: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        permissions: [],
      },
      loading: false,
      loadingButton: false,
      validationsMessage: {
        form: {
          name: {
            required: "Insira o nome completo",
          },
          email: {
            email: "Insira um email válido",
          },
        },
      },
      roles: [],
      permissions: [],
    };
  },
  validations() {
    return {
      form: {
        name: { required },
        email: { email },
        permissions: [],
      },
    };
  },
  methods: {
    getErrors(error) {
      const errors = Object.values(error.response.data.errors);
      const message = errors
        .map((item) => item.map((error) => `<li>${error}</li>`).join(""))
        .join("");

      this.$buefy.dialog.alert({
        title: "Não foi possível salvar o usuário",
        message: `<ul>${message}</ul>`,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
      });
    },
    fetchRoles() {
      rolesUserShowRequest().then((res) => {
        this.roles = res.data.data;
        this.permissions = this.roles?.permissions;
      });
    },
    async onSubmit() {
      await this.$v.$touch();
      if (this.$v.form.$invalid) {
        this.$snack.error("Preencha corretamente o formulário");
        return;
      }
      if (!this.form.permissions.length) {
        this.$snack.error("Selecione no mínimo uma permissão para o usuário");
        return;
      }
      this.loadingButton = true;
      usersCreateRequest(this.form)
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.$snack.success("Usuário salvo com sucesso");
          this.$router.push({ name: "users.index" });
        })
        .catch((error) => {
          this.getErrors(error);
        })
        .finally(() => (this.loadingButton = false));
    },
  },
  mounted() {
    this.fetchRoles();
  },
};
</script>
